export const appConfig = {
  backend_url: process.env.REACT_APP_BACKEND_URL,
  release_date: process.env.RELEASE_DATE,
  release_type: process.env.REACT_APP_RELEASE_TYPE || 'TF_ORIGIN',
  event_url: process.env.REACT_APP_EVENT_URL,
  print_url: process.env.REACT_APP_PRINT_URL,
  report_url: process.env.REACT_APP_REPORT_URL,
  report_auth: process.env.REACT_APP_REPORT_AUTH || 'YWRtaW46anNyZXBvcnQ1NTY3',
  graphql_endpoint: process.env.REACT_APP_GRAPH_ENDPOINT,
  graphql_ws_endpoint: process.env.REACT_APP_GRAPH_WS_ENDPOINT,
  public_csv:
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQJknHA9bunlWJXzAOGlLJ-mPOQ60vQRWyY0o35Vd5QZn_w1mAEd1npOg7cuiBwSy9-CwuAf7PnHX18/pub?output=csv',
  profile_key: 'profile',
  token_key: 'accessToken',
  auth_type: 'auth_type',
  siteName: 'B-Logistics',
  footer: '© 2025 B-Logistics',
  googleMapKey:
    process.env.REACT_APP_GOOGLE_MAP_KEY ||
    'AIzaSyAQQwW_pYRr_vSSfq-9EBlbdFB6Xdd8V4g',
};

export enum BACKEND_SERVICES {
  /* authenticate local and jwt (refresh token) */
  AUTH = 'authentication',
  USERS = 'users',
  /* list, get, process product */
  /* others */
  COMMON_SERVICE = 'common',
}
